import { Shift } from '@/models'
import { SHIFT_FAILURE, SHIFT_REQUEST, SHIFT_SUCCESS } from '@/redux/actionTypes'

export interface ShiftState {
    shift: Shift | null
    loading: boolean
    errors: unknown[]
}

export type ShiftAction =
    | { type: typeof SHIFT_REQUEST }
    | { type: typeof SHIFT_SUCCESS, shift: Shift | null }
    | { type: typeof SHIFT_FAILURE, errors: unknown[] }

const initialState: ShiftState = {
    shift: null,
    loading: false,
    errors: [],
}

export const shiftReducer = (state: ShiftState = initialState, action: ShiftAction): ShiftState => {
    switch (action.type) {
        case SHIFT_REQUEST:
            return { ...state, loading: true }
        case SHIFT_SUCCESS:
            return {
                ...state, loading: false, shift: action.shift,
            }
        case SHIFT_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        default:
            return state
    }
}
